if (!customElements.get('pouches-tabs')) {
  customElements.define('pouches-tabs', class extends HTMLElement {
    connectedCallback() {
      this.buttons = this.querySelectorAll('[role="tab"]');
      this.panels = this.querySelectorAll('[role="tabpanel"]');
      this.buttons.forEach(btn => btn.addEventListener('click', () => this.select(btn)));
    }

    select(btn) {
      this.buttons.forEach(b => {
        b.setAttribute('aria-selected', b === btn);
        b.classList.toggle('pouches-tab--active', b === btn);
      });
      this.panels.forEach(p => {
        p.hidden = p.id !== btn.getAttribute('aria-controls');
      });
    }
  });
}
